module.exports = __webpack_public_path__ + "static/media/online-music-course.1cadd973.jpeg";